import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  items: Crumb[];
}

export default function Breadcrumb({ items }: Props) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-700 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800 font-medium" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}